import { axiosHrClient } from '../plugins/axios'

const employee = {
  namespaced: true,

  actions: {
    getSystemMenus() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hrportal/self/catelogroles/13/programitemroles'
          )
          let list_obj = {}
          res.data.data.forEach(item => {
            if (!Array.isArray(list_obj[item.programCatelogFullNameTha]))
              list_obj[item.programCatelogFullNameTha] = []
            list_obj[item.programCatelogFullNameTha].push({
              name: item.programItemFullNameTha,
              programItemMenuID: item.programItemMenuID,
              itemPath: item.programItemPath,
              otherSystem: item.otherSystem
            })
          })
          const list = []
          for (let key in list_obj) {
            list.push({
              title: key,
              menus: list_obj[key]
            })
          }
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },

    getTypeDropdown() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get('/hrreference/employeetypeall')
          resolve(
            res.data.data.map(item => {
              return {
                text: item.employeeTypeNameTha,
                value: item.employeeTypeId
              }
            })
          )
        } catch (e) {
          reject(e)
        }
      })
    },

    getOrganizatioDropdown(ctx, extendPath) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hr/self/organization/2/accessrole/13/parent' + extendPath
          )
          resolve(
            res.data.data.map(item => {
              return {
                text: item.organizationNameTha,
                value: item.organizationID
              }
            })
          )
        } catch (e) {
          reject(e)
        }
      })
    },

    getLeaveCheckerOrgDropdown(ctx, extendPath) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hr/self/organization/2/accessrole/119/parent' + extendPath
          )
          resolve(
            res.data.data.map(item => {
              return {
                text: item.organizationNameTha,
                value: item.organizationID
              }
            })
          )
        } catch (e) {
          reject(e)
        }
      })
    },

    postSearch(ctx, body) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post('/hr/employeessearch', body)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getEmployeeInfo(ctx, name) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post('/EmployeeInfoSearch', {
            KeySearch: name
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default employee
